import styled from 'styled-components';

export const RouteText = styled.h5`
  margin: 0;
  margin-left: 7px;
  font-weight: 500;
  font-style: italic;
  color: #000;
`;
